const REQUEST_FUNDS_SUPPORTING_FILE_MAX_BYTES = 10 * 1024 * 1024;
const REQUEST_FUNDS_SUPPORTING_FILE_MAX_COUNT = 10;

const REQUEST_FUNDS_SUPPORTING_FILE_EXTENSIONS = new Set([
  "pdf",
  "jpg",
  "jpeg",
  "png",
  "doc",
  "docx",
  "xls",
  "xlsx",
]);

export function getRequestFundsSupportingFileExtension(fileName) {
  const text = String(fileName ?? "").trim().toLowerCase();
  const dot = text.lastIndexOf(".");
  if (dot < 0) {
    return "";
  }
  return text.slice(dot + 1);
}

export function isRequestFundsSupportingFileAllowed(file) {
  if (!(file instanceof File)) {
    return false;
  }
  if (file.size > REQUEST_FUNDS_SUPPORTING_FILE_MAX_BYTES) {
    return false;
  }
  const ext = getRequestFundsSupportingFileExtension(file.name);
  return REQUEST_FUNDS_SUPPORTING_FILE_EXTENSIONS.has(ext);
}

export function mergeRequestFundsSupportingFileSelection(existingFiles, pickedFiles) {
  const current = Array.isArray(existingFiles) ? [...existingFiles] : [];
  const incoming = Array.from(pickedFiles ?? []).filter(isRequestFundsSupportingFileAllowed);
  const merged = [...current];
  for (const file of incoming) {
    if (merged.length >= REQUEST_FUNDS_SUPPORTING_FILE_MAX_COUNT) {
      break;
    }
    const duplicate = merged.some(
      (existing) =>
        existing.name === file.name &&
        existing.size === file.size &&
        existing.lastModified === file.lastModified,
    );
    if (!duplicate) {
      merged.push(file);
    }
  }
  return merged;
}

export function buildFundRequestSupportingFilesFormData(files) {
  const formData = new FormData();
  const list = Array.isArray(files) ? files : [];
  for (const file of list) {
    if (file instanceof File) {
      formData.append("files", file);
    }
  }
  return formData;
}
